import { render, staticRenderFns } from "./AssessmentFormSection.vue?vue&type=template&id=3dba4746"
import script from "./AssessmentFormSection.vue?vue&type=script&lang=js"
export * from "./AssessmentFormSection.vue?vue&type=script&lang=js"
import style0 from "./AssessmentFormSection.vue?vue&type=style&index=0&id=3dba4746&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports